import { useCookies } from 'react-cookie'

const useLoginDetector = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, _setCookie] = useCookies(['u-tel'])
  const isLogin = cookies['u-tel'] !== undefined

  const isLoginCallHandler = (isLoginCallBackFn: () => void, isNotLoginCallBackFn: () => void) => {
    isLogin ? isLoginCallBackFn() : isNotLoginCallBackFn()
  }
  return { isLoginCallHandler, isLogin }
}
export default useLoginDetector
